var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSoonGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 391,
    viewBox: "0 0 676 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 4.49133 197.53)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 342.315 387.578)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 28.0057 211.105)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 365.829 374.002)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9531 224.93L389.786 29.8965",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 389.344 360.428)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 75.0345 238.255)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 412.858 346.852)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 98.5488 251.83)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 436.372 333.277)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 122.063 265.405)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 459.887 319.703)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 145.578 278.979)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 483.401 306.127)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 169.092 292.556)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 506.916 292.551)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 192.597 306.127)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 530.43 278.977)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 216.111 319.703)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 553.944 265.402)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 239.626 333.277)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 577.459 251.827)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.231 346.905L601.064 151.871",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 600.973 238.252)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 286.654 360.428)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 624.487 224.677)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 310.169 374.002)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 648.002 211.102)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 333.683 387.578)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 671.516 197.527)",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonGrid);
export default __webpack_public_path__ + "static/media/img-soon-grid.8ee79240d7a5e17ca8fb191fc4019510.svg";
export { ForwardRef as ReactComponent };